// extracted by mini-css-extract-plugin
module.exports = {"separator":"LatestNewsBoxCluster_separator__MhNF3","inBox":"LatestNewsBoxCluster_inBox__ClDlC","latestNewsBoxContainer":"LatestNewsBoxCluster_latestNewsBoxContainer__Y46Xs"};